<template>
    <app-tabela
        :itens="rateio"
        :campos="campos"
        :itensPorPagina="itensPorPagina"
        :mostrarFiltro="false"
        :bordered="false"
        :small="false"
    >
        <template slot="valor" slot-scope="data">{{
            data.valor | currency
        }}</template>
        <template slot="unidade" slot-scope="data"
            >({{ data.codUnidade }}) {{ data.unidade }}</template
        >
        <template slot="projeto" slot-scope="data"
            >({{ data.codProjeto }}) {{ data.projeto }}</template
        >
        <template slot="acao" slot-scope="data"
            >({{ data.codAcao }}) {{ data.acao }}</template
        >
        <template slot="percentual" slot-scope="data">{{
            data.percentual
                | currency({
                    symbol: '%',
                    thousandsSeparator: '.',
                    fractionCount: 2,
                    fractionSeparator: ',',
                    symbolPosition: 'back',
                    symbolSpacing: false
                })
        }}</template>
        <template slot="botoes">
            <slot name="botoes"></slot>
        </template>
        <template slot="acoes" slot-scope="data">
            <!-- <btn-atualizar-dotacao
                :tipo="operacao"
                v-if="operacao != 'D'"
                :valorTotal="valorASerRateado"
                :valorDisponivel="valorDisponivel"
                :rateio="data"
                @atualizarRateio="$emit('atualizarRateio', $event)"
            ></btn-atualizar-dotacao> -->
            <btn-excluir-dotacao
                v-if="operacao != 'D'"
                :rateio="data"
                @excluirRateio="$emit('excluirRateio', data)"
            ></btn-excluir-dotacao>
            <btn-justificativa
                :rateio="data"
                v-if="data.justificativa"
            ></btn-justificativa>
            <slot name="acoes" v-bind="data"></slot>
        </template>
    </app-tabela>
</template>

<script>
// import BtnAtualizarDotacao from './BtnAtualizarDotacao'
import BtnExcluirDotacao from './BtnExcluirDotacao'
import BtnJustificativa from './BtnJustificativa'

export default {
    components: {
        // BtnAtualizarDotacao,
        BtnExcluirDotacao,
        BtnJustificativa
    },

    props: {
        rateio: {
            type: Array,
            default: () => []
        },

        temAcoes: {
            type: Boolean,
            default: () => false
        },

        valorASerRateado: {
            type: Number,
            default: () => 0
        },

        valorDisponivel: {
            type: Number,
            default: () => 0
        },

        operacao: {
            type: String,
            default: () => 'D'
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'unidade',
                    label: 'Unidade',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'projeto',
                    label: 'Projeto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acao',
                    label: 'Ação',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'percentual',
                    label: 'Percentual',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    sortable: true,
                    type: 'datetime',
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        ajustaTabela() {
            if (!this.temAcoes) {
                this.campos.pop()
            } else {
                this.campos.push({
                    key: 'acoes',
                    label: 'Ações'
                })
            }
        }
    },

    watch: {
        temAcoes() {
            this.ajustaTabela()
        }
    },

    created() {
        this.ajustaTabela()
    }
}
</script>
